import React, { useEffect } from "react";
import { FaBell, FaCommentAlt, FaHeart, FaShare, FaSearch, FaChevronDown } from "react-icons/fa";
import pipaanlogo from "../../assets/pipaanlogo.png";
import groupimg from "../../assets/groupimg.png";
import userimg from "../../assets/user.png";
import profileimg from "../../assets/profile.png";
import share from "../../assets/share.png";
import newsfeed from "../../assets/images/icons/newsfeed.png";
import calendar from "../../assets/images/icons/calendar.png";
import location from "../../assets/images/icons/location.png";
import editcover from "../../assets/images/icons/edit-2.png";
import { MoreHorizontal } from "lucide-react";
import edit from "../../assets/images/icons/edit.png";
import mobile from "../../assets/images/icons/mobile.png";
import house from "../../assets/images/icons/house.png";
import friendsfollowers from "../../assets/images/icons/friendsandfollowers.png";
import groupsandfamily from "../../assets/images/icons/groupandfamily.png";
import chats from "../../assets/images/icons/chats.png";
import profile from "../../assets/images/icons/profile.png";
import camera from "../../assets/images/icons/camera.png";
import locationicon from "../../assets/images/icons/location.png";
import mobileicon from "../../assets/images/icons/mobile.png";
import Account from "../../assets/images/icons/account-setting.png";
import help from "../../assets/images/icons/helpandsupport.png";
import logout from "../../assets/images/icons/logout.png";
import notification from "../../assets/images/icons/notification.png";
import gallery from "../../assets/images/icons/gallery.png";
import video from "../../assets/images/icons/video.png";
import taguser from "../../assets/images/icons/tag-user.png";
import send from "../../assets/images/icons/send.png";
import global from "../../assets/images/icons/global.png";
import hamburger from "../../assets/images/icons/hamburger.png";
import hamburgerclose from "../../assets/images/icons/hamburgerclose.png";
import closecircle from "../../assets/images/icons/close-circle.png";
import FeedPost from "../feedpost/FeedPost";
import profileData from "../feedpost/profiledata";
import { Menu, X, Bell, User, Home, Edit } from "lucide-react";
import { useState } from "react";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { FaTimes } from "react-icons/fa";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Navigation, Pagination } from "swiper/modules";
import profilebanner from "../../assets/images/Profile-banner.png";
import Add from "../../assets/images/icons/add-circle.png";
import Danger from "../../assets/images/icons/danger.png";
import Attach from "../../assets/images/icons/link.png";
import Trash from "../../assets/images/icons/trash.png";
import axios from "axios";
import Editicon from "../../assets/images/icons/edit.png"
import { friendRequests, groupData } from '../nestedtab/friendRequestsData';


const Adminpanel = ({ matchedGroup }) => {
    const [isOpen, setIsOpen] = useState(false);  // << move useState at the top
    const [isEditingGroup, setIsEditingGroup] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [users, setUsers] = useState([]);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const groupId = 39; // You can dynamically set this if needed
    const [followers, setFollowers] = useState([]);
    const [groupMembers, setGroupMembers] = useState(matchedGroup.members || []);

    // Fetch followers (on modal open)
    useEffect(() => {
        if (showModal) {
            fetchFollowers();
        }
    }, [showModal]);

    const fetchFollowers = async () => {
        const token = sessionStorage.getItem("accessToken");
        const userID = sessionStorage.getItem("userID");

        if (!token) return console.error("No token found, please log in.");

        try {
            const response = await fetch("https://pipaan.com360degree.com/api/friend/get-friends", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "token": `${token}`,
                },
                body: JSON.stringify({
                    filters: { allFollowers: true },
                    page: 1,
                    limit: 10,
                }),
            });

            if (!response.ok) throw new Error(`Error: ${response.status}`);

            const data = await response.json();
            const formattedFollowers = data.result.friends.map((friend) => ({
                friend_id: friend.id,
                user1id: friend.User1.id,
                first_name: friend.User1.first_name,
                username: friend.User1.username,
                profile_picture_url: friend.User1.profile_picture_url || userimg,
            }));

            setFollowers(formattedFollowers);
        } catch (error) {
            console.error("Error fetching followers:", error);
        }
    };

    const handleAddMember = async () => {
        const token = sessionStorage.getItem("accessToken");
        if (!selectedUserId || !token) return;

        try {
            await axios.post(
                "https://pipaan.com360degree.com/api/group_member/add-group_member",
                {
                    group_id: groupId,
                    user_id: selectedUserId,
                    role: "member",
                },
                {
                    headers: { token },
                }
            );

            // ✅ Fetch user info to append (or fetch updated list)
            const newUser = followers.find(user => user.user1id === selectedUserId);
            if (newUser) {
                const newMember = {
                    id: newUser.friend_id, // Or API response ID
                    role: "member",
                    user: {
                        id: selectedUserId,
                        first_name: newUser.first_name,
                        last_name: "", // optional if available
                        username: newUser.username,
                        profile_picture_url: newUser.profile_picture_url,
                    },
                };

                setGroupMembers((prev) => [...prev, newMember]);
            }

            alert("Member added!");
            setShowModal(false);
        } catch (error) {
            alert("Error adding member: " + error.message);
        }
    };



    const [editedGroup, setEditedGroup] = useState({
        group_name: matchedGroup.group_name || "",
        description: matchedGroup.intro || "",
        group_image: matchedGroup.group_image || "",
        group_cover: matchedGroup.group_cover || "",
    });

    if (!matchedGroup) {
        return <p className="text-red-500 text-center">No matching group found!</p>;
    }

    const toggleDropdown = () => setIsOpen(!isOpen);
    const handleGroupUpdate = async () => {
        const token = sessionStorage.getItem("accessToken");
        const requestBody = {
            group_id: matchedGroup.id,
            group_name: editedGroup.group_name,
            description: editedGroup.description,
            group_image: editedGroup.group_image, // you can hook this to an upload field
            group_cover: editedGroup.group_cover,
            is_deleted: false,
        };

        try {
            const response = await fetch("https://pipaan.com360degree.com/api/group/edit-group", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    token,
                },
                body: JSON.stringify(requestBody),
            });

            const result = await response.json();
            if (result.success) {
                alert("Group updated successfully");
                setIsEditingGroup(false);
                // Optional: refresh page or update matchedGroup locally
            } else {
                alert("Failed to update group: " + result.message);
            }
        } catch (error) {
            console.error("Error updating group:", error);
            alert("An error occurred while updating the group.");
        }
    };

    return (

        <div className="dashboard w-full min-h-screen  flex max-w-screen-lg mx-auto">
            <main className="flex p-2 w-full">

                {/* Main Content */}
                <main className="flex w-full">

                    {/* Feeds */}
                    <div className="flex-1 space-y-6">

                        <div className="profile-content ">
                            <div className="relative w-full ">
                                {/* Cover Photo */}
                                <img
                                    src={matchedGroup.group_cover || profilebanner}
                                    alt="Group Cover"
                                    className="w-full  object-cover cover-img" />

                                {/* Edit Button */}
                                <button className="edit-cover absolute top-0 right-12 bg-[#FFFFFF80] bg-opacity-50 text-[#161F28] px-4 py-2 text-sm flex items-center space-x-2 hover:bg-opacity-75 transition">
                                    <img src={editcover} alt="edit" className="w-4 h-4" />
                                    <span>Edit Cover</span>
                                </button>
                            </div>

                            <div className=" space-y-3 mt-7 profile-body relative">
                                <div className="flex items-end w-full  top-[0px]   absolute justify-between">
                                    <div className="flex items-end relative profile-abs-content-left left-5 top-[-9px]">
                                        <div className="profile-dashboard profile-page-dashboard overflow-hidden relative ">
                                            {/* Profile Image Upload */}
                                            <label className="relative cursor-pointer">
                                                <input type="file" accept="image/*" className="hidden" />
                                                <img
                                                    src={matchedGroup.group_image || userimg}
                                                    alt="Profile" className="w-full h-full object-cover" />

                                                <div className="absolute">
                                                    <img src={camera} alt="Edit" className=" text-white" />
                                                </div>
                                            </label>
                                        </div>
                                        <div className="feed-title pl-4 relative">
                                            {/* <p className="font-semibold text-[28px]">{matchedGroup.group_name}</p> */}
                                            {isEditingGroup ? (
                                                <div className="space-y-2">
                                                    <input
                                                        type="text"
                                                        value={editedGroup.group_name}
                                                        onChange={(e) => setEditedGroup({ ...editedGroup, group_name: e.target.value })}
                                                        className="border border-gray-300 p-2 rounded w-full"
                                                        placeholder="Group Name"
                                                    />
                                                    <textarea
                                                        value={editedGroup.description}
                                                        onChange={(e) => setEditedGroup({ ...editedGroup, description: e.target.value })}
                                                        className="border border-gray-300 p-2 rounded w-full"
                                                        placeholder="Group Description"
                                                    />

                                                    {/* Group Image URL */}
                                                    <input
                                                        type="text"
                                                        value={editedGroup.group_image || ""}
                                                        onChange={(e) => setEditedGroup({ ...editedGroup, group_image: e.target.value })}
                                                        className="border border-gray-300 p-2 rounded w-full"
                                                        placeholder="Group Image URL"
                                                    />

                                                    {/* Group Cover Image URL */}
                                                    <input
                                                        type="text"
                                                        value={editedGroup.group_cover || ""}
                                                        onChange={(e) => setEditedGroup({ ...editedGroup, group_cover: e.target.value })}
                                                        className="border border-gray-300 p-2 rounded w-full"
                                                        placeholder="Group Cover Image URL"
                                                    />
                                                </div>
                                            ) : (
                                                <>
                                                    <p className="font-semibold text-[28px]">{matchedGroup.group_name}</p>
                                                    <p className="text-sm text-[#747474]">{matchedGroup.intro}</p>
                                                </>
                                            )}

                                            <p className="flex text-sm text-[#747474]">
                                                <span className="flex items-center followers-profile ml-1 cursor-pointer">
                                                    {/* Follower Images */}
                                                    {/* {matchedGroup.followerImages?.slice(0, 4).map((img, index) => (
                                                            <img
                                                                key={index}
                                                                src={img}
                                                                alt={`Follower ${index + 1}`}
                                                                className="w-6 h-6 rounded-full border-2 border-white -ml-2 first:ml-0"
                                                            />
                                                        ))} */}
                                                    {/* Follower Count */}
                                                    {/* <span className="ml-2">{matchedGroup.followers} Followers</span> */}
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="edit-profile mb-5">
                                        {isEditingGroup ? (
                                            <div className="flex gap-2">
                                                <button
                                                    onClick={handleGroupUpdate}
                                                    className="bg-[#095228] text-white px-4 py-2 rounded"
                                                >
                                                    Update
                                                </button>
                                                <button
                                                    onClick={() => setIsEditingGroup(false)}
                                                    className="bg-gray-300 text-black px-4 py-2 rounded"
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                        ) : (
                                            <button
                                                onClick={() => setIsEditingGroup(true)}
                                                className="bg-[#095228] text-white flex items-center px-4 py-2 rounded"
                                            >
                                                <img src={Editicon} alt="Edit" className="mr-2" />
                                                <span>Edit</span>
                                            </button>
                                        )}
                                    </div>

                                </div>
                                <div className="user-intro ">
                                    <div className="user-intro-flex  my-5">
                                        <div className="adminpanel-intro ">
                                            <h4 className="font-semibold">Intro</h4>
                                            <p>{matchedGroup.intro}</p>
                                        </div>

                                    </div>
                                </div>
                                <div className="grp-screen-cta flex items-center gap-2 py-2 rounded-lg">
                                    {/* Search Input */}
                                    <div className="flex items-center border border-gray-300 bg-white rounded-full px-3 py-2 find">
                                        <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-4.35-4.35"></path>
                                            <circle cx="10.5" cy="10.5" r="7.5"></circle>
                                        </svg>
                                        <input type="text" placeholder="Add Members" className="ml-2 text-gray-500 outline-none bg-transparent" />
                                        <div className="hidden md:block">
                                            <button
                                                onClick={() => setShowModal(true)}

                                                className=" flex items-center gap-2 bg-green-800 text-white px-4 py-1 mx-1 rounded-full add ">
                                                <img src={Add} alt="Edit" className=" text-white" /><span className="text-sm text-[#fff]">Add Memberr</span>
                                            </button>
                                            {/* Modal */}
                                            {/* Modal */}
                                            {showModal && (
                                                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                                                    <div className="bg-white p-6 rounded-lg w-96">
                                                        <h2 className="text-lg font-semibold mb-4">Select a Follower</h2>

                                                        <div className="max-h-60 overflow-y-auto mb-4">
                                                            {followers.length === 0 ? (
                                                                <p>No followers found.</p>
                                                            ) : (
                                                                followers.map((user) => (
                                                                    <div
                                                                        key={user.friend_id}
                                                                        className={`flex items-center gap-3 p-2 rounded hover:bg-gray-100 cursor-pointer ${selectedUserId === user.user1id ? "bg-gray-200" : ""
                                                                            }`}
                                                                        onClick={() => setSelectedUserId(user.user1id)}
                                                                    >
                                                                        <img
                                                                            src={user.profile_picture_url}
                                                                            alt={user.username}
                                                                            className="w-10 h-10 rounded-full"
                                                                        />
                                                                        <div>
                                                                            <p className="font-medium">{user.first_name}</p>
                                                                            <p className="text-sm text-gray-500">@{user.username}</p>
                                                                        </div>
                                                                    </div>
                                                                ))
                                                            )}
                                                        </div>

                                                        <div className="flex justify-end gap-2">
                                                            <button
                                                                onClick={() => setShowModal(false)}
                                                                className="px-3 py-1 bg-gray-400 text-white rounded"
                                                            >
                                                                Cancel
                                                            </button>
                                                            <button
                                                                onClick={handleAddMember}
                                                                className="px-3 py-1 bg-green-600 text-white rounded"
                                                                disabled={!selectedUserId}
                                                            >
                                                                Add
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="flex items-center ctas">
                                        {/* Buttons */}
                                        {/* <button className=" flex items-center gap-2 bg-green-800 text-white px-4 py-1 mx-1 rounded-full add">
                                                    <img src={Add} alt="Edit" className=" text-white" /><span className="text-sm text-[#fff] hidden md:block">Add Member+</span>
                                                </button> */}

                                        <button className="flex items-center gap-2 bg-green-800 text-white px-4 py-[10px] mx-1 rounded-full invite">
                                            <img src={Attach} alt="Edit" className=" text-white" /><span className="text-sm text-[#fff] hidden md:block"> Invite to Group Via Link</span>
                                        </button>

                                        <button className="flex items-center gap-2 bg-[#F9E9EA] border border-[#BE1F2E] text-[#BE1F2E] px-4 py-[10px] mx-1 rounded-full">
                                            <img src={Trash} alt="Edit" className=" text-white" /><span className="text-sm text-[#BE1F2E] hidden md:block">Delete</span>
                                        </button>

                                        <button className="flex items-center gap-2 bg-[#F9E9EA] border border-[#BE1F2E] text-[#BE1F2E] px-4 py-[10px] mx-1 rounded-full">
                                            <img src={Danger} alt="Edit" className=" text-white" /><span className="text-sm text-[#BE1F2E] hidden md:block">Report</span>
                                        </button>
                                    </div>
                                </div>

                            </div>

                        </div>
                        <div className=" followers followers-friends-profile followers-responsive justify-between border-b-0 border-[#fff] pb-6 md:hidden">
                            <div className="flex w-full">
                                <img src={userimg} alt="User" className="w-15 h-15 rounded-full" />
                                <div className="pl-4 w-full">
                                    <div className="flex items-center justify-between">
                                        <p className="titlesemibold pb-1 pr-5">Marketing Group</p>

                                    </div>
                                    <p className="text-[12px] text-[#747474] pb-1">
                                        @prvnk_sky
                                    </p>
                                    {/* <p className="members">764 Followers <span className="text-[#D9D9D9]">|</span> <span className="italic text-[#095228b8] text-[10px] underline">4 Mutual Followers</span></p> */}
                                </div>

                            </div>
                            <div className="flex follow-unfollow-cta justify-end w-full">
                                <button className="follow-cta my-2">Add Member</button>
                                {/* <button className="follow-cta-block my-2">Block</button> */}
                            </div>
                        </div>
                        <div className="grp-admin-count">
                            <p>
                                {matchedGroup.acceptedMembersCount} Group Members |{" "}
                                {matchedGroup.adminCounts} Admins
                            </p>                        </div>
                        <div className="feed-tabs profile-page-feeds w-full mx-auto text-center lg:text-left">
                            <div className="flex relative w-full ">
                                <div className="fasearch">
                                    <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-300" /></div>
                                <input
                                    type="text"
                                    placeholder="Find Your Friend"
                                    className="search-input focus:outline-none focus:ring-2 focus:ring-[#e5e7eb] bg-[#FFFFFF]"
                                />

                            </div>

                            <div className="feed-tabs profile-page-feeds w-full mx-auto text-center lg:text-left">
                                {groupMembers.map((member) => (
                                    <div
                                        key={member.id}
                                        className="followers followers-friends-profile justify-between border-b-2 border-[#161f2833] pb-6"
                                    >
                                        <div className="flex w-full">
                                            <img
                                                src={member.user.profile_picture_url || userimg}
                                                alt={member.user.first_name}
                                                className="w-15 h-15 rounded-full"
                                            />
                                            <div className="pl-4 w-full md:flex align-items justify-between">
                                                <div className="w-full">
                                                    <p className="titlesemibold pb-1 pr-5">
                                                        {member.user.first_name} {member.user.last_name}
                                                    </p>
                                                    <p className="text-[12px] text-[#747474] pb-1">
                                                        @{member.user.username}
                                                    </p>
                                                    <p className="members">
                                                        {/* Role: {member.role} | Status: {member.status} */}
                                                    </p>
                                                </div>
                                                <div className="w-full relative btn-drp-userpage">
                                                    <button
                                                        onClick={toggleDropdown}
                                                        className="flex absolute right-0 justify-center w-8 h-8 rounded-full hover:bg-gray-100 menu-btn-userpage"
                                                    >
                                                        <MoreHorizontal size={18} />
                                                    </button>
                                                    {isOpen && (
                                                        <div className="absolute right-8 mt-2 w-40 bg-green-50 rounded-md shadow-lg z-10">
                                                            <div className="py-2 text-center text-sm text-black">
                                                                <div className="px-4 py-2 hover:bg-green-100 cursor-pointer">Mark Group Admin</div>
                                                                <hr className="my-1 border-green-200" />
                                                                <div className="px-4 py-2 hover:bg-green-100 cursor-pointer">Remove</div>
                                                                <hr className="my-1 border-green-200" />
                                                                <div className="px-4 py-2 hover:bg-green-100 cursor-pointer">Unfollow</div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                        </div>
                    </div>
                </main>
            </main>
        </div >
    );
}

export default Adminpanel;

